<template>
  <div class="position-relative">
    <!-- Input (solo visible mientras se edita) -->
    <input
      v-show="editando"
      ref="inputRef"
      class="form-control"
      style="min-height: 45px"
      type="text"
      :value="modelValue"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
    >

    <!-- Vista previa estilo input (visible cuando no se edita) -->
    <div
      v-show="!editando"
      class="form-control d-flex align-items-center flex-wrap gap-1"
      style="min-height: 45px; cursor: text;"
      @click="activarEdicion"
    >
      <template v-if="segmentos && segmentos.length">
        <template v-for="(seg, sidx) in segmentos" :key="'seg_' + sidx">
          <span v-if="seg.type === 'pill'" class="badge bg-primary text-white me-1">{{ seg.text }}</span>
          <span v-else>{{ seg.text }}</span>
        </template>
      </template>
      <template v-else>
        <span class="text-secondary">—</span>
      </template>
    </div>

    <!-- Lista desplegable de propiedades -->
    <div v-if="mostrarLista && editando" class="list-group position-absolute w-100 mt-1" style="z-index: 1060; max-height: 220px; overflow:auto;">
      <button
        v-for="(prop, idx) in propiedades || []"
        :key="'auto_prop_' + idx"
        type="button"
        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
        @mousedown.prevent="insertToken(prop)"
      >
        <span>{{ prop.nombre }}</span>
        <small class="text-secondary">{{ prop.grupo || 'Sin grupo' }}</small>
      </button>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';

export default {
  name: 'AutonombreInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    propiedades: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const mostrarLista = ref(false);
    const editando = ref(false);
    const inputRef = ref(null);

    const onInput = (e) => {
      emit('update:modelValue', e.target.value);
    };

    const onFocus = () => {
      mostrarLista.value = true;
      editando.value = true;
    };

    const onBlur = () => {
      setTimeout(() => {
        mostrarLista.value = false;
        editando.value = false;
      }, 150);
    };

    const activarEdicion = () => {
      editando.value = true;
      requestAnimationFrame(() => {
        inputRef.value?.focus();
      });
    };

    const insertToken = (prop) => {
      if (!prop || !prop.id) return;
      const token = `##${prop.id}##`;
      const input = inputRef.value;
      const base = props.modelValue || '';
      if (input && input.selectionStart != null) {
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const nuevo = base.slice(0, start) + token + base.slice(end);
        emit('update:modelValue', nuevo);
        requestAnimationFrame(() => {
          const pos = start + token.length;
          input.setSelectionRange(pos, pos);
          input.focus();
        });
      } else {
        emit('update:modelValue', base + token);
      }
    };

    const segmentos = computed(() => {
      const texto = props.modelValue || '';
      const regex = /##(\d+)##/g;
      const segs = [];
      let lastIndex = 0;
      let match;
      while ((match = regex.exec(texto)) !== null) {
        if (match.index > lastIndex) {
          segs.push({ type: 'text', text: texto.slice(lastIndex, match.index) });
        }
        const idBuscado = Number(match[1]);
        const prop = (props.propiedades || []).find(p => Number(p.id) === idBuscado);
        const etiqueta = prop ? prop.nombre : `#${idBuscado}`;
        segs.push({ type: 'pill', text: etiqueta });
        lastIndex = match.index + match[0].length;
      }
      if (lastIndex < texto.length) {
        segs.push({ type: 'text', text: texto.slice(lastIndex) });
      }
      return segs;
    });

    return {
      mostrarLista,
      editando,
      inputRef,
      onInput,
      onFocus,
      onBlur,
      activarEdicion,
      insertToken,
      segmentos,
    };
  }
}
</script>

<style scoped>
</style>


